module.exports = __webpack_public_path__ + "img/home_btn.3f81465a.png";